import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';
import firstProcessOnboardingContainer from 'assets/img/onboarding_bg_1.png';
import secondProcessOnboardingContainer from 'assets/img/onboarding_bg_2.png';

export const useStyles = makeStyles((theme) => ({
    action: {
        width: '100%',
        background: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingTop: 8,
        paddingBottom: 8,
        height: 61,
    },
    content: {
        width: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        maxHeight: '100%',
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        background: themes.palette.primary.light,
        padding: 12,
        borderRadius: 12,
        overflow: 'hidden',
    },
    button: {
        width: 152,
        height: 44,
        padding: 0,
        fontSize: 14,
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.main,
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textTransform: 'uppercase',
        border: 'none',
        color: themes.palette.common.white,
    },
    buttonNormal: {
        width: 90,
        height: 44,
        padding: 0,
        fontSize: 14,
        fontWeight: 'bold',
        fontFamily: 'PoppinsRegular',
        background: 'transparent',
        color: themes.palette.primary.main,
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textTransform: 'uppercase',
        border: 'none',
    },
    firstProcessOnboardingContainer: {
        backgroundImage: `url(${firstProcessOnboardingContainer})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: 10,
        borderRadius: 12,
    },
    secondProcessOnboardingContainer: {
        backgroundImage: `url(${secondProcessOnboardingContainer})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: 10,
        borderRadius: 12,
    },
    thirdProcessOnboardingContainer: {
        backgroundColor: 'rgb(33, 37, 41)',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        justifyContent: 'center',
        borderRadius: 12,
    },
    slideItem: {
        flex: 1,
    },
    subSlideTitle: {
        fontFamily: 'PoppinsRegular',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        textAlign: 'center',
        color: '#FFFFFF',
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(2px)',
        marginBottom: 16,
        padding: '4px 8px',
        borderRadius: 46,
    },
}));
